import React, { useEffect } from "react";
import DigitalPpc from "../components/service/DigitalPpc";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalGoogle from "../components/service/DigitalGoogle";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const DigitalMarketing = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="Google Ads agency in Chennai,
                  Google Ads expert in Chennai,
                  Google Ads services India,
                  Best Google Ads company,
                  Google Ads for lead generation,
                  Local Google Ads services in india,
                  Google Shopping ads management,
                  Local Google Ads expert near me,
                  Google Ads services in Chennai,
                  digital marketing company in Chennai,
                  digital marketing company in India,
                  best digital marketing agency Chennai,
                  best digital marketing agency India,
                  marketing company for small business Chennai,
                  marketing company for small business India,
                  affordable digital marketing in Chennai,
                  affordable digital marketing in India,
                  digital marketing services for business Chennai,
                  digital marketing services for business India,
                  digital marketing for startups Chennai,
                  digital marketing for startups India"
        />
        <title>Google Ads Marketing | PPC Campaign | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Boost leads and sales with expert Google Ads Marketing services. Run search, display, video, and shopping ads with smart targeting and measurable ROI."
        />
      </Helmet>

      <div>
        <Navbar />
        <DigitalGoogle />
        <Footer />
      </div></>

  );
};

export default DigitalMarketing;
